import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { githubCopy } from '@/copy'
import { githubAppApi, holdPendingAppSetup } from '../api/githubApp'
import { GitHubAppSetupView } from '../components/GitHubAppSetupView'

/**
 * GitHub's manifest-flow `redirect_url`: completes the App setup with the
 * one-time `code` and `state`, then sends the user on to install the App.
 * The exchange runs as the signed-in user, so only whoever started the
 * flow can finish it.
 */
export function GitHubAppCallbackPage() {
  const [params] = useSearchParams()
  const code = params.get('code')
  const state = params.get('state')
  const [exchangeError, setExchangeError] = useState<string | null>(null)
  // The code is single-use: guard against StrictMode's double effect.
  const started = useRef(false)

  useEffect(() => {
    if (started.current || !code || !state) return
    started.current = true
    githubAppApi
      .exchange(code, state)
      .then(({ connection_id, install_url }) => {
        // The App's setup_url (/github-app/setup) continues on this
        // connection's page.
        holdPendingAppSetup(connection_id)
        window.location.assign(install_url)
      })
      .catch((e: unknown) =>
        setExchangeError(
          githubCopy.callback.exchangeFailed(
            e instanceof Error ? e.message : String(e),
          ),
        ),
      )
  }, [code, state])

  const error = code && state ? exchangeError : githubCopy.callback.noCode

  return <GitHubAppSetupView error={error} />
}
